export enum DataFilterAction {
  Copy = 'Copy',
  Update = 'Update',
  Delete = 'Delete',
  Edit = 'Edit',
  Add = 'Add',
}
